import Link from "next/link";
import type { ReactNode } from "react";

export type MarketingHeroLink = {
  href: string;
  label: string;
  icon?: ReactNode;
};

type MarketingHeroSecondaryLinksProps = {
  links: readonly MarketingHeroLink[];
  className?: string;
};

/** Matches App Store / Google Play button rhythm in AppStoreDownloadButtons */
const linkClassName =
  "inline-flex items-center justify-center gap-2 w-full min-w-0 min-h-16 px-6 py-3 rounded-xl border border-slate-300 bg-white text-slate-700 hover:bg-slate-100 hover:border-slate-400 font-semibold text-base leading-snug transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-white dark:border-slate-600/70 dark:bg-slate-800/30 dark:text-slate-200 dark:hover:bg-slate-700/40 dark:hover:border-slate-500/80 dark:focus:ring-slate-500/80 dark:focus:ring-offset-slate-950 [&_svg]:size-4 [&_svg]:shrink-0";

export function MarketingHeroSecondaryLinks({
  links,
  className = "",
}: MarketingHeroSecondaryLinksProps) {
  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 gap-2 w-full ${className}`}
    >
      {links.map((link) => (
        <Link key={link.href} href={link.href} className={linkClassName}>
          {link.icon}
          <span className="min-w-0 text-center">{link.label}</span>
        </Link>
      ))}
    </div>
  );
}
